import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserType } from "src/models/Maintenance/UserType.models";

interface UserTypeState {
  userTypes: IUserType[];
  userTypeToEdit: IUserType | null;
}

const initialState: UserTypeState = {
  userTypes: [],
  userTypeToEdit: null,
};

const userTypeSlice = createSlice({
  name: "UserType",
  initialState,
  reducers: {
    setUserTypeList: (state, action: PayloadAction<IUserType[]>) => {
      state.userTypes = action.payload;
    },
    concatListUserType: (
      state: UserTypeState,
      action: PayloadAction<IUserType[]>
    ) => {
      state.userTypes = [...state.userTypes.concat(action.payload)];
    },
    setUserTypeToEdit: (state, action: PayloadAction<IUserType | null>) => {
      state.userTypeToEdit = action.payload;
    },
    addUserType: (state, action: PayloadAction<IUserType>) => {
      state.userTypes.push(action.payload);
    },
    updateUserType: (state, action: PayloadAction<IUserType>) => {
      let itemIndex = state.userTypes.findIndex(
        item => item.userTypeId === action.payload.userTypeId
      );
      if (itemIndex !== -1) state.userTypes[itemIndex] = action.payload;
    },
    deleteUserType: (state, action: PayloadAction<number>) => {
      const newArray = state.userTypes.filter(
        item => item.userTypeId !== action.payload
      );
      state.userTypes = newArray;
    },
  },
});

export const {
  setUserTypeList,
  concatListUserType,
  setUserTypeToEdit,
  addUserType,
  updateUserType,
  deleteUserType,
} = userTypeSlice.actions;

export default userTypeSlice.reducer;
